import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../auth/services/auth.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  imports:[CommonModule, FormsModule],
  standalone: true,
  selector: 'app-twofa-setup',
  templateUrl: './twofa-setup.component.html'
})
export class TwofaSetupComponent implements OnInit {

  qrCode:string = ""
  secret:string = ""
  otpCode:string = ""

  loading:boolean = false
  success:boolean = false
  error:string = ""

  constructor(private auth:AuthService){}

  ngOnInit(){
    this.loadSetup()
  }

  loadSetup(){

    this.auth.setup2FA()
      .subscribe((res:any)=>{

        this.secret = res.secret
        this.qrCode = res.qr

      })

  }

  verify(){

    if(!this.otpCode){
      this.error = "Enter verification code"
      return
    }

    this.loading = true

    this.auth.verify2FA({ code: this.otpCode })
      .subscribe({

        next:(res)=>{
          this.success = true
          this.loading = false
        },

        error:()=>{
          this.error = "Invalid code"
          this.loading = false
        }

      })

  }

}
